import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { SIP_LABEL, SIP_STATUS } from '../SipDetailsV2/SipDetailV2';

import BigImpacts from '../BigImpacts';
import TaxBenefits from '../TaxBenefits';

import mailIcon from '../../public/images/sip-select/mail.png';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import mailRedDotIcon from '../../public/images/sip-select/mail_red_dot.png';
import KettoBird from '../../public/images/ketto-logo-1.png';

//education images
import edu2 from '../../public/images/pledge-more/edu2.png'
//food and hunger images
import hun2 from '../../public/images/pledge-more/hun2.png'
// animals images
import ani2 from '../../public/images/pledge-more/ani2.png'
// medical images
import med2 from '../../public/images/pledge-more/med2.png'
// elderly images
import eld2 from '../../public/images/pledge-more/eld2.png'
// acid victims images
import av2 from '../../public/images/pledge-more/av2.png'
// women cause images
import wom2 from '../../public/images/pledge-more/wom2.png'
//widow images
import wid2 from '../../public/images/pledge-more/wid2.png'

import './SubcribedCausePage.scss';
import { UserLoginContext } from '../../../contexts/LoggedInUserContext';
import { fetchSubscriptionCurrency, getPledgeAmt, handlePledgeMoreLink, handleReturnDayDiff } from '../../../services/helperFunctions';
import SipSummaryCard from '../SipSummaryCard/SipSummaryCard';
import { getImpactInfo, sendEvents } from '../../../redux/actions/Home';
import UrgentNeedCardV2 from '../UrgentNeedCardV2/UrgentNeedCardV2';
import avatarUrl from './../../public/images/allocate-funds/af_icon.png';
import { Dialog } from '@material-ui/core';
import AllocateFundBannerCard from '../AllocatedFund/AllocateFundBannerCard/AllocateFundBannerCard';
import { getSelectionList, getAllocatedFunds } from '../../../redux/actions/AllocateFunds';
import AllocateFundPage from '../AllocatedFund/AllocateFundPage/AllocateFundPage';
import EllipsisLoader from '../EllipsisLoader';
import { useIsMobile } from '../../hooks/useIsMobile';
import PledgeMorePage from '../PledgeMorePage/PledgeMorePage';

const pmpImg = {
  education: edu2,
  food_hunger: hun2,
  animals: ani2,
  medical: med2,
  elderly: eld2,
  acid_victims: av2,
  women_girls: wom2,
  widow: wid2,
}

const SubcribedCausePage = ({ cause, causeDetail, sipStatus ,setOpenPledgeMoreDialog}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile()
  const { userData, latestOrder } = useContext(UserLoginContext);
  const params = new URLSearchParams(location.search);
  const shouldAllocate = params.get('allocate') === 'true';
  const shouldPledge = params.get('pledge') === 'true';

  const currency = fetchSubscriptionCurrency(latestOrder, userData);
  const amount = localStorage.getItem('sipAmount');
  const newAmount = currency && getPledgeAmt(currency.toUpperCase(), parseInt(amount));
  const dayDiff = latestOrder && latestOrder?.next_payment_date && handleReturnDayDiff(latestOrder?.next_payment_date);

  //State
  const [isLoading, setIsLoading] = useState(true);
  const [orderInfo, setOrderInfo] = useState([]);
  const [showAllocateFundDialog, setShowAllocateFundDialog] = useState(false);
  const [showPledgeMoreDialog, setShowPledgeMoreDialog] = useState(false);


  const [allocateFundData, setAllocateFundData] = useState([]);
  const [existingAllocatedFundList, setExistingAllocatedFundsList] = useState([]);
  const [buttonText, setButtonText] = useState('');
  const [contentText, setContentText] = useState('');

  //UseEffect
  useEffect(() => {
    getImpactInfo().then((res) => {
      setOrderInfo(res?.data?.data?.data);
    });
    if (latestOrder?.next_payment_date != null && sipStatus === SIP_STATUS.ACTIVE && (dayDiff <= 4 && dayDiff > 0) && latestOrder?.campaign_cause === 'medical') {
     handleGetAllocatedFunds().then((res) => {
      const beneficiaryName = res[0]?.campaign?.beneficiary_name;
        setExistingAllocatedFundsList(res);
        setButtonText(res.length > 0 ? 'CHANGE SELECTION' : 'PICK A FUNDRAISER');
        setContentText(res.length > 0 && beneficiaryName ?
          `You have selected <b>${beneficiaryName}'s fundraiser</b> to receive your upcoming SIP contribution`:
          'Take a moment to pick a fundraiser that feels right for your upcoming SIP contribution');
      });
    }
    setIsLoading(false);
  }, [])

  useEffect(() => {
    if (shouldAllocate) {
      handleGetFundList();
    }
  }, [shouldAllocate]);

  useEffect(() => {
    if (shouldPledge) {
      handleOpenPledgeMoreDialog();
    }
  }, [shouldPledge]);

  const handleCancelSip = () => {
    navigate('/cancelsip')
  }

  const handlePledgeMore = () => {
    handlePledgeMoreLink(amount, newAmount, '', userData.email, cause);
  }

  const handleChooseAnotherFundraiserCTA = () => {
    sendEvents('allocate_fundraiser_cta','sip_returning','sip_home_page', buttonText, true);
    handleGetFundList();
  }

  const handleGetAllocatedFunds = async () => {
    const resp = getAllocatedFunds(userData?.id, latestOrder?.currency).then((res) => {
      return res?.data?.data?.data;
    });
    return resp;
  };

  const handleGetFundList = async () => {
    setIsLoading(true);
    try {
      const res = await getSelectionList();
      const fundData = res.data.data;
      setAllocateFundData(fundData);
      if (!isMobile) {
        setShowAllocateFundDialog(true);
      } else {
        navigate('/allocatefunds', { state: { allocateFundData: fundData, existingAllocatedFundList: existingAllocatedFundList } });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenPledgeMoreDialog=()=>{
    setIsLoading(true);
    try {
      if(!isMobile){
         setShowPledgeMoreDialog(true);
      }else{
        navigate("/pledge-more", {state : {causeDetail : causeDetail}})
      }
    } finally {
      setIsLoading(false);
    }
  }

  //giving this function to parent component
  useEffect(() => {
    setOpenPledgeMoreDialog && setOpenPledgeMoreDialog(() => handleOpenPledgeMoreDialog);
  }, []);

  return (
    <>
      {isLoading && <div className='component-loader'><EllipsisLoader /></div>}
      <SipSummaryCard campaign_cause={cause} causeDetail={causeDetail} sipStatus={sipStatus} handlePledgeMore={handlePledgeMore} handleOpenPledgeMoreDialog={handleOpenPledgeMoreDialog} />
      <UpdateUI />
      {sipStatus === SIP_STATUS.ACTIVE && <PlegdeMoreCardUI handleOpenPledgeMoreDialog={handleOpenPledgeMoreDialog} latestOrder={latestOrder} />}
      {latestOrder?.next_payment_date != null && sipStatus === SIP_STATUS.ACTIVE && (dayDiff <= 4 && dayDiff > 0) && latestOrder?.campaign_cause === 'medical' && buttonText && contentText && <AllocateFundBannerCard avatarUrl={avatarUrl} onChooseAnotherFundraiserCTA={handleChooseAnotherFundraiserCTA} buttonText={buttonText} contentText={contentText}/>}
      <TaxBenefits />
      {orderInfo?.length <= 2 && <UrgentNeedCardV2 />}
      <BigImpacts campaign_cause={cause} />
      {sipStatus === SIP_STATUS.ACTIVE && <CancelSipUI cause={cause} handleCancelSip={handleCancelSip} />}

      <Dialog
        open={showAllocateFundDialog}
        scroll="paper"
        onClose={() => {
          setShowAllocateFundDialog(false);
        }}
        PaperProps={{
          style: {
            borderRadius: '16px',
            width: '100%',
            maxWidth:'650px'
          },
        }}
      >
        <AllocateFundPage allocateFundData={allocateFundData} existingAllocatedFundList={existingAllocatedFundList} />
      </Dialog>

       <Dialog
        open={showPledgeMoreDialog}
        scroll="paper"
        onClose={() => {
          setShowPledgeMoreDialog(false);
        }}
        PaperProps={{
          style: {
            borderRadius: '16px',
            width: '100%',
            width: '500px',
            maxWidth:'500px'
          },
        }}
      > 
       <PledgeMorePage causeDetail={causeDetail}/>
      </Dialog>
    </>
  )
}

export default SubcribedCausePage;

//micro UIs
export const UpdateUI = () => (
    <div className='update-container-wrapper'>
        <Link to="/updates">
            <div className='update-container'>
                <div className="icon-container">
                    <img
                        loading="lazy"
                        src={mailIcon}
                        alt="mail"
                        className="mail-icon"
                    />
                    <img
                        loading="lazy"
                        src={mailRedDotIcon}
                        alt="notification"
                        className="mail-dot-icon"
                    />
                </div>
                <span className="update-text">View Donation Updates</span>
                <ArrowForwardIosIcon className="arrow-icon mfs-16" />
            </div>
        </Link>
    </div>
);

export const CancelSipUI = ({ cause, handleCancelSip }) => (
    <div className='cancel-sip-container' onClick={handleCancelSip}>
        {`Cancel My ${SIP_LABEL[cause]} SIP`}
        <ArrowForwardIcon />
    </div>
);

export const PlegdeMoreCardUI = ({ handleOpenPledgeMoreDialog, latestOrder }) => {
  const { campaign_cause } = latestOrder
  return (
    <div className="pledge-card">
      <img src={KettoBird} alt="ketto-bird" className="ketto_bird-1" />
      <img src={KettoBird} alt="ketto-bird" className="ketto_bird-2" />
      <svg className="image-highlight" xmlns="http://www.w3.org/2000/svg" width="209" height="128" viewBox="0 0 209 128" fill="none">
        <g opacity="0.5" filter="url(#filter0_f_6897_12314)">
          <ellipse cx="118.064" cy="70.7884" rx="38.0641" ry="35.8314" fill="#DDF6F7" fillOpacity="0.4" />
        </g>
        <g opacity="0.5" filter="url(#filter1_f_6897_12314)">
          <ellipse cx="157.96" cy="80.1778" rx="38.0641" ry="35.6398" fill="#DDF6F7" fillOpacity="0.4" />
        </g>
        <g opacity="0.5" filter="url(#filter2_f_6897_12314)">
          <ellipse cx="136.286" cy="37.6398" rx="52.1184" ry="35.6398" fill="#DDF6F7" fillOpacity="0.4" />
        </g>
        <defs>
          <filter id="filter0_f_6897_12314" x="0" y="-45.043" width="236.128" height="231.663" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="40" result="effect1_foregroundBlur_6897_12314" />
          </filter>
          <filter id="filter1_f_6897_12314" x="39.8955" y="-35.4619" width="236.128" height="231.279" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="40" result="effect1_foregroundBlur_6897_12314" />
          </filter>
          <filter id="filter2_f_6897_12314" x="4.16748" y="-78" width="264.237" height="231.279" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="40" result="effect1_foregroundBlur_6897_12314" />
          </filter>
        </defs>
      </svg>
      <div className="pledge-text-content">
        <div className='pledge-text'>
          <p className='pledge-title'>Boost your impact</p>
          <p className='pledge-subtitle'>Join us in making a greater impact by giving more often.</p>
        </div>
        <button className="pledge-button" onClick={handleOpenPledgeMoreDialog}>
          PLEDGE MORE <span><ArrowForwardIcon className="btn-arrow" /></span>
        </button>
      </div>
      <div className={`${campaign_cause}`}>
        <img src={pmpImg[campaign_cause]} alt="pledge-illustration" />
      </div>
    </div>
  );
};